<template>
<div>
<v-toolbar dark class="primary">
    <v-btn @click.native="$router.push('/home')" icon>
        <v-icon>chevron_left</v-icon>
    </v-btn>
    <v-toolbar-title>Document Checklist</v-toolbar-title>

    <v-spacer></v-spacer>

    <v-btn @click="showDocumentDialog(null)" icon>
        <v-icon>add_circle</v-icon>
    </v-btn>
</v-toolbar>

<div class="pa-4">
    <div class="heading">{{lender}}
        <v-menu offset-y left>
            <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" class="blue--text">
                <v-icon>keyboard_arrow_down</v-icon>
            </v-btn>
            </template>
            <v-list>
                <v-list-item v-for="lender in lenders" @click="showDocumentDialog(null, category)" :key="lender.key">
                    <v-list-item-title>{{ lender.name }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>        
    </div>

    <div v-for="document in documents" :key="document.key">
        <div class="heading">{{document.title}}</div>

        <div class="mt-2">
            <b>{{getPreferredOption(document).title}}</b>
        </div>
        <div>
            {{getPreferredOption(document).description}} 
             | <a href="" @click.prevent="showOptionDialog(document.key, document.preferredIndex, getPreferredOption(document))">Edit</a>

        </div>

        <div class="mb-3 mt-3">
            Other Options: 
            <template v-for="(option, index) in document.options">
                <span v-if="true" :key="index">
                    <a href="" @click.prevent="setPreferredIndex(document, index)">{{option.title}}</a> | 
                </span>
            </template>  
            <a href="" @click.prevent="showOptionDialog(document.key, null, null)">Create New Option</a> 
        </div>
    </div>
</div>


<!--Dialogs-->

<DialogBox :settings="documentDialog.settings" @save="saveDocumentDialog">
    <div class="pa-4">
        <v-text-field 
            v-model="documentDialog.document.title" 
            label="Title"
            ref="documentTitle"
            maxlength="30"
            @change="setDefaultName" 
        />
        <v-text-field v-model="documentDialog.document.name" label="Name" />
    </div>
</DialogBox>

<DialogBox :settings="optionDialog.settings" @save="saveOptionDialog">
    <div class="pa-4">
        <v-text-field 
            v-model="optionDialog.option.title" 
            label="Title"
            maxlength="30"
            ref="optionTitle"
        />
        <v-text-field v-model="optionDialog.option.description" label="Description" />
    </div>
</DialogBox>

</div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import DeleteButton from '../ui-elements/DeleteButton'
import DialogBox from '../ui-elements/DialogBox'
import FirebaseHelpers from '../helpers/FirebaseHelpers'
import DataHelpers from '../helpers/DataHelpers';
import FireData from '../data/FireData';
import StringHelpers from '../helpers/StringHelpers';
import OrderHelpers from '../helpers/OrderHelpers';


var db = firebase.database()
var lendersRef = db.ref('app/lenders')
var categoriesRef = db.ref('app/documents/categories')
var requirementsRef = db.ref('app/documents/requirements')
var requestsRef = db.ref('app/documents/requests/General')
var generalRequestsRef = db.ref('app/documents/requests/General')

export default {
    name: 'LenderDocuments',
    components: {
        DeleteButton,
        DialogBox,
    },
    data() {
        return {
            dialogTab: '0',
            lender: 'General',
            newCheckItem: '',
            documents: [],



            documentDialog: {
                settings: {
                    key: null,
                    visible: false,
                    title: 'Document Details',
                },
                document: this.createDocument(),

            },
            optionDialog: {
                settings: {
                    index: null,
                    visible: false,
                    title: 'Option Details',
                },
                documentKey: null,
                option: this.createOption(),
            },
            requirementDialog: {
                visible: false,
                tab: 'main-tab',
                model: {
                    name: '',
                    description: '',
                    download: '',
                    importance: 0,
                    instructions:'',
                    checklist: [],
                    notRequired: false,
                    expiryDays: null
                }
            }
        }
    },

    firebase: {
            lenders: lendersRef,
            categories: categoriesRef,
            requirements: requirementsRef,
            requests: requestsRef,
            generalRequests: generalRequestsRef
    },        
    computed: {

        dialogHeight() {
            if(this.$vuetify.breakpoint.smAndDown)
                return '100%'
            else
                return '500px'
        },

    },
    methods: {
        getPreferredOption(document) {
     
            if(
                !document 
                || document.preferredIndex == null
                || !document.options
                || document.options.length <= document.preferredIndex
            )
                return this.createOption()

            return document.options[document.preferredIndex] || this.createOption()
        },

        //mutate obj to remove key, and pass back what it was (or a new one)
        extractOrMakeKey(obj) {
            let returnVal
            if(obj.key) {
                returnVal = obj.key
                delete obj.key
            } else
                returnVal = DataHelpers.getKey()
                
        },
        saveDocumentDialog() {
            let document = this.documentDialog.document
            saveDocument(document)
        },

        saveDocument(document) {
            console.log('saving', document)
            let ref = db.ref('app/documents/lenders').child(this.lender)
            FireData.saveItem(document, ref)
        },
        
        saveOptionDialog() {
            console.log('saving option')
        
            let document = this.documents.find(o => o.key == this.optionDialog.documentKey)

            //temporary
            if(!document.options)
                document.options = []

            if(this.optionDialog.optionIndex > -1)
                document.options[this.optionDialog.optionIndex] = this.optionDialog.option
            else
                document.options.push(this.optionDialog.option)
            this.saveDocument(document)
        },

        setDefaultName() {
            let doc = this.documentDialog.document
            if(!doc.name)
                doc.name = StringHelpers.toSnakeCase(doc.title)
        },

        setLender(name) {
            this.lender = name
            var requestsRef = db.ref('app/documents/requests').child(name)
            this.$bindAsArray('requests', requestsRef)
        },

        showDocumentDialog (document) {
            document = document || this.createDocument()
            this.documentDialog.document = document
            this.documentDialog.settings.visible = true
            this.$nextTick(()=>{

                this.$refs.documentTitle.focus()
            })
        },

        showOptionDialog (documentKey, optionIndex, option) {
            option = option || this.createOption()
            this.optionDialog.option = option
            this.optionDialog.documentKey = documentKey
            this.optionDialog.optionIndex = optionIndex
            this.optionDialog.settings.visible = true
            this.$nextTick(()=>{
                this.$refs.optionTitle.focus()
            })
        },

        createDocument() {
            return {
                title: null,
                name: null,
                order: OrderHelpers.orderKey(),
                options: [],
            }
        },
        createOption() {
            return {
                title: null,
                name: null,
                order: OrderHelpers.orderKey()
            }
        },

        setPreferredIndex(document, index) {
            document.preferredIndex = index
            this.saveDocument(document)
        },

        showRequirementDialog (model, requirement) {
            if(model) {
                if(typeof(model.notRequired) === "undefined")
                    model.notRequired = false
                this.requirementDialog.model = JSON.parse(JSON.stringify(model))
            } else {
                this.requirementDialog.model.requirementName = requirement.name
                this.requirementDialog.model.requirementKey = requirement['.key']
            }
            
            this.requirementDialog.visible = true
        },

        requirementDialogClose () {
            this.requirementDialog.visible = false
            this.requirementDialog.model = 
                {name: '', 
                description:'', 
                importance: 0, 
                download: '', 
                instructions:'', 
                checklist: [], 
                category: {},
                notRequired: false,
                expiryDays: null}
            this.requirementDialog.tab = 'main-tab'
        },
        requirementDialogCancel () {
            this.requirementDialogClose()
        },
        requirementDialogSave () {
            let ref = db.ref('app/documents/requests').child(this.lender)
            let model = this.requirementDialog.model
            this.pushOrUpdateRef(model, ref)
            this.requirementDialogClose()
        },
        deleteRequirement (key) {
            db.ref('app/documents/requests').child(this.lender).child(key).remove()
            
            this.requirementDialogClose()
        },


        requirementsForCategory (category) {
            return this.requirements.filter(req => req.category.name == category)
        },
        requestsForRequirement (type) {
            //return this.requests
            let requests =  this.requests.filter(req => req.requirementKey == type)
            requests = requests.sort((a, b) => b.importance - a.importance)
            return requests
        },
        generalRequestsForRequirement (type) {
            //return this.requests
            let requests =  this.generalRequests.filter(req => req.requirementKey == type)
            requests = requests.sort((a, b) => b.importance - a.importance)
            return requests
        },
        pushOrUpdateRef(model, ref) {
            let key = model['.key']
            if(key){
                ref = ref.child(key) 
                delete model['.key']
                
                ref.update(model)
            } else {
                ref.push(model)
            }
        },
        addCheckItem() {
            if(!this.requirementDialog.model.checklist)
                this.requirementDialog.model.checklist = []

            this.requirementDialog.model.checklist.push({
                text: this.newCheckItem
            })
            this.newCheckItem = ''
        },
        copyToLender (request) {
            let ref = db.ref('app/documents/requests/' + this.lender)
            ref.push(FirebaseHelpers.cloneWithoutKey(request))

        }

    },
    created() {
        let generalRef = db.ref('app/documents/lenders/General')
        generalRef.on('value', snap => {
            this.documents = FireData.snapshotToArray(snap)
        })
    }
}

</script>

<style>



</style>


// WEBPACK FOOTER //
// LenderDocuments.vue?19fa6516